import { type ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps): JSX.Element {
  return (
    <div className="auth-layout">
      {children}

      <style>{`
        .auth-layout {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f0 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
}
